export default __webpack_public_path__ + "static/media/c4.4f0af54b.png";